// extracted by mini-css-extract-plugin
export default {"header":"Home_header__6-AUA","categorias":"Home_categorias__gWGHj","categorias-container":"Home_categorias-container__FVGQI"};